import { useEffect } from "react";

// Remove the Greek tonos (acute accent, U+0301) while KEEPING dialytika (U+0308).
const stripTones = (s) => s.normalize("NFD").replace(/\u0301/g, "").normalize("NFC");

function processTree(root) {
  if (!root || !root.querySelectorAll) return;
  const elements = root.querySelectorAll(".uppercase");
  elements.forEach((el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const v = node.nodeValue;
      if (v && v.normalize("NFD").indexOf("\u0301") !== -1) {
        const nv = stripTones(v);
        if (nv !== v) node.nodeValue = nv;
      }
    }
  });
}

// Strips accents from any element rendered in all-caps (Tailwind `uppercase`),
// following Greek typographic rules. Runs on mount and re-applies on DOM changes.
export function useUppercaseNoTones() {
  useEffect(() => {
    const run = () => processTree(document.body);
    run();
    const obs = new MutationObserver(() => window.requestAnimationFrame(run));
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => obs.disconnect();
  }, []);
}
